document.addEventListener('DOMContentLoaded', function () {
    
    // 1. Cria o Overlay Global se não existir
    let overlay = document.getElementById('wpmundi-popup-overlay');
    if (!overlay) {
        const html = `
            <div id="wpmundi-popup-overlay">
                <div class="wpmundi-popup-container">
                    <div class="wpmundi-popup-injector"></div>
                </div>
            </div>`;
        document.body.insertAdjacentHTML('beforeend', html);
        overlay = document.getElementById('wpmundi-popup-overlay');
    }

    const injector = overlay.querySelector('.wpmundi-popup-injector');

    // Funções de Controle
    const closeModal = () => {
        overlay.classList.remove('is-active');
        document.body.style.overflow = '';
        setTimeout(() => { 
            if(!overlay.classList.contains('is-active')) injector.innerHTML = ''; 
            
            // Opcional: Limpar as variáveis ao fechar para evitar lixo residual
            overlay.style.removeProperty('--wpmundi-popup-overlay-color');
            overlay.style.removeProperty('--wpmundi-popup-max-width');
        }, 300);
    };

    const openModal = (contentSource) => {
        const clone = contentSource.cloneNode(true);
        
        clone.classList.remove('wpmundi-popup-hidden-source');
        clone.style.display = 'flex';
        clone.style.flexDirection = 'column';

        injector.innerHTML = '';
        injector.appendChild(clone);

        // --- LÓGICA DE FECHAR INTERNA ---
        const closeActionBlock = clone.querySelector('.wpmundi-close-action');
        if (closeActionBlock) {
            closeActionBlock.addEventListener('click', closeModal);
        }
        
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden'; 
    };

    // 2. Event Listeners (Gatilhos de Abrir)
    const triggers = document.querySelectorAll('.wpmundi-popup-trigger-element');
    
    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            const parent = trigger.parentElement; 
            
            // --- ATUALIZAÇÃO AQUI ---
            // Em vez de ler atributos, lemos as Variáveis CSS do Wrapper (Pai)
            const wrapperColor = parent.style.getPropertyValue('--wpmundi-popup-overlay-color');
            const wrapperWidth = parent.style.getPropertyValue('--wpmundi-popup-max-width');

            // 1. Aplica a COR (se existir) no Overlay Global
            if (wrapperColor) {
                overlay.style.setProperty('--wpmundi-popup-overlay-color', wrapperColor);
            } else {
                // Se não tiver, remove para usar o padrão do CSS
                overlay.style.removeProperty('--wpmundi-popup-overlay-color'); 
            }

            // 2. Aplica a LARGURA (se existir) no Overlay Global
            // (O container filho vai herdar essa variável)
            if (wrapperWidth) {
                overlay.style.setProperty('--wpmundi-popup-max-width', wrapperWidth);
            } else {
                overlay.style.removeProperty('--wpmundi-popup-max-width');
            }
            // ------------------------

            const content = parent.querySelector('.wpmundi-popup-hidden-source');
            
            if (content) {
                openModal(content);
            }
        });
    });

    // Fechar clicando fora ou ESC
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal();
    });
});